import store from '../Store/index';

const student_routes = [
  {
    path: '/student-list',
    component: () => import('../Pages/Student/StudentList.vue'),
    name: 'StudentList',
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    meta: {
      requiresAuth: true,
      part: 'students'
    }
  },
  {
    path: '/additional-data',
    component: () => import('../Pages/Student/PedagogicalData.vue'),
    name: 'PedagogicalData',
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    meta: {
      requiresAuth: true,
      part: 'students'
    }
  },
  {
    path: '/student-print-list',
    component: () => import('../Pages/Prints/StudentListPrint.vue'),
    name: 'StudentListPrint',
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    meta: {
      requiresAuth: true,
      part: 'students'
    }
  },
  {
    path: '/service-order-print',
    component: () => import('../Pages/Prints/ServiceOrderPrint.vue'),
    name: 'ServiceOrderPrint',
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    meta: {
      requiresAuth: true,
      part: 'students'
    }
  },
  {
    path: '/home-visit-blank',
    component: () => import('../Components/Blanks/HomeVisit/BlankPage.vue'),
    name: 'HomeVisit',
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    meta: {
      requiresAuth: true,
      part: 'students'
    }
  },
  {
    path: '/chat',
    component: () => import('../Pages/Chat.vue'),
    name: 'Chat',
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/calendar',
    component: () => import('../Pages/Calendar.vue'),
    name: 'VueCal',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/audittrail',
    component: () => import('../Pages/Audittrail.vue'),
    name: 'Audittrail',
    meta: {
      requiresAuth: true
    }
  },
  {
    // Legacy StudyCenterNew day calendar — redirect to v2 so the old
    // page is unreachable (menu, bookmarks, named routes).
    path: '/centers/:slug/day',
    name: 'StudyCenterNew',
    redirect: to => ({
      path: `/study-center-v2/${to.params.slug}/day`,
      query: to.query
    }),
    meta: {
      requiresAuth: true
    }
    // component: () => import('../Pages/StudyCenterNew/StudyCenterNew.vue'),
    // beforeEnter: (to, from, next) => {
    //   to.meta.part = to.params.slug;
    //   if (store.state.auth.user.entity_id === 2) {
    //     next({ name: 'ReproachesSchedule' });
    //   } else {
    //     next();
    //   }
    // }
  },
  {
    path: '/student-schedule',
    component: () => import('../Pages/StudyCenterNew/ReproachesSchedule.vue'),
    name: 'ReproachesSchedule',
    meta: {
      requiresAuth: true,
      part: 'study-center'
    }
  },
  {
    path: '/student-security',
    component: () => import('../Pages/StudentPages/SecurityStudent.vue'),
    name: 'SecurityStudent',
    meta: {
      requiresAuth: true,
      part: 'students'
    }
  },
  {
    path: '/student-lesson-requests',
    component: () => import('../Pages/StudentPages/LessonApplications.vue'),
    name: 'StudentLessonApplications',
    meta: {
      requiresAuth: true,
      part: 'students'
    }
  },
  {
    path: '/document-editor',
    component: () => import('../Pages/StudyCenterNew/DocumentEditor.vue'),
    name: 'DocumentEditor',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    // Legacy StudyCenterNew week calendar — redirect to v2.
    path: '/centers/:slug/week',
    name: 'StudyCenterNewWeek',
    redirect: to => ({
      path: `/study-center-v2/${to.params.slug}/week`,
      query: to.query
    }),
    meta: {
      requiresAuth: true
    }
    // component: () => import('../Pages/StudyCenterNew/StudyCenterNewWeek2.vue'),
    // beforeEnter: (to, from, next) => {
    //   to.meta.part = to.params.slug;
    //   if (store.state.auth.user.entity_id === 2) {
    //     next({ name: 'ReproachesSchedule' });
    //   } else {
    //     next();
    //   }
    // }
  },
  {
    path: '/mobile-dashbord',
    component: () => import('../Pages/HomeDashboard.vue'),
    name: 'MobileDashbord',
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      // Students get their own dashboard (prod behavior)
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'StudentDashboardHome' });
      } else {
        next();
      }
    }
  },
  {
    path: '/new-student-list',
    component: () => import('../Pages/NewStudent/NewStudentList.vue'),
    name: 'NewStudentList',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/graduated-student-list',
    component: () =>
      import('../Pages/GraduatedStudent/GraduatedStudentList.vue'),
    name: 'GraduatedStudentList',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/deleted-student-list',
    component: () => import('../Pages/DeletedStudent/DeletedStudentList.vue'),
    name: 'DeletedStudentList',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/students-security',
    component: () => import('../Pages/Security/TeacherPermits'),
    name: 'StudentsSecurity',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/students-security-students-page',
    component: () => import('../Pages/Security/TeacherPermits'),
    name: 'StudentsSecurity',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/scan-page',
    component: () => import('../Pages/Security/Blocks/QRScanTab.vue'),
    name: 'QRScanTab',
    meta: {
      requiresAuth: true,
      part: 'security'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/scan-select',
    component: () => import('../Pages/Security/Blocks/ScanSelectPage.vue'),
    name: 'ScanSelectPage',
    meta: {
      requiresAuth: true,
      part: 'security'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/controllers',
    component: () => import('../Pages/Security/Blocks/Controllers.vue'),
    name: 'Controllers',
    meta: {
      requiresAuth: true,
      part: 'security'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/students-security-print',
    component: () => import('../Pages/Prints/TeacherPermitsPrint'),
    name: 'StudentsSecurity',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/kicked-student-list',
    component: () => import('../Pages/KickedStudent/KickedStudentList.vue'),
    name: 'KickedStudentList',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/dashboard/:id',
    component: () => import('../Pages/MainDashboard.vue'),
    name: 'MainDashboard',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-dashboard/:id',
    component: () => import('../Pages/Student/StudentDashboard.vue'),
    name: 'StudentDashboard',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-behavior/:id',
    component: () => import('../Pages/Student/StudentBehavior.vue'),
    name: 'StudentBehavior',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-reproaches-tab/:id',
    component: () => import('../Pages/Student/StudentReproachesTab.vue'),
    name: 'StudentReproachesTab',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-boarding-school/:id',
    component: () => import('../Pages/Student/StudentCenter.vue'),
    name: 'StudentCenter',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },

  {
    path: '/student-project/:id',
    component: () => import('../Pages/Student/StudentProject.vue'),
    name: 'StudentProject',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-school/:id',
    component: () => import('../Pages/Student/StudentSchool.vue'),
    name: 'StudentSchool',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-add',
    component: () => import('../Pages/Student/StudentAdd.vue'),
    name: 'StudentAdd',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/parent-blank',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/ParentBlank.vue'),
    name: 'ParentBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/new-blank-1/:id',
    component: () =>
      import('../Pages/BehaviorBlank/StuffBlank/newStuffBlank.vue'),
    name: 'NewBlank1',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/new-blank-2/:id',
    component: () => import('../Pages/BehaviorBlank/PlanBlank/PlanBlank.vue'),
    name: 'NewBlank2',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/plan-blank-allStudents',
    component: () =>
      import('../Pages/BehaviorBlank/PlanBlank/PlanBlankAllStudents.vue'),
    name: 'PlanBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/plan-blank/:id/blank',
    component: () =>
      import('../Pages/BehaviorBlank/PlanBlank/ViewPlanBlank.vue'),
    name: 'ViewPlanBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/nuclear-stuff-blank/:id/blank',
    component: () =>
      import('../Pages/BehaviorBlank/StuffBlank/ViewStuffBlank.vue'),
    name: 'ViewStuffBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/nuclear-stuff-blank-tables',
    component: () => import('../Pages/BehaviorBlank/StuffBlankTables.vue'),
    name: 'StuffBlankTables',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/plan-blank-tables',
    component: () => import('../Pages/BehaviorBlank/PlanBlankTables.vue'),
    name: 'PlanBlankTables',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/nuclear-stuff-blank-all-student',
    component: () =>
      import('../Pages/BehaviorBlank/StuffBlank/StuffBlankAllStudent.vue'),
    name: 'ViewStuffBlankAll',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/personal-conversation-blank',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/PCBlank.vue'),
    name: 'PersonalConversationBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/feedback-blank',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/FeedbackBlank.vue'),
    name: 'FeedbackBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/assessment-blank',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/AssessmentBlank.vue'),
    name: 'AssessmentBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/incident-blank',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/IncidentBlank.vue'),
    name: 'IncidentBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/commission-blank',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/CommissionBlank.vue'),
    name: 'CommissionBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/exit-permission-blank',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/ExitPermissionBlank.vue'),
    name: 'ExitPermissionBlank',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/exit-permission-blank/:id',
    component: () =>
      import('../Pages/Student/Blocks/StudentBehavior/ExitPermissionBlank.vue'),
    name: 'ExitPermissionBlankId',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },

  {
    path: '/student-data/:id/',
    component: () => import('../Pages/Student/StudentEdit.vue'),
    name: 'StudentEdit',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-additional-data/:id/',
    component: () => import('../Pages/Student/StudentAdditionaDataTable.vue'),
    name: 'StudentAdditionaDataTable',
    meta: {
      requiresAuth: true,
      part: 'students',
      layout: 'student-layout'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/incident-blank-view',
    component: () =>
      import('../Pages/Student/Blocks/BlankView/IncidentBlankView.vue'),
    name: 'IncidentBlankView',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:slug/students-report',
    component: () => import('../Pages/Reports/Day.vue'),
    name: 'ReportsDay',
    meta: {
      requiresAuth: true,
      part: 'center'
    },
    beforeEnter: (to, from, next) => {
      to.meta.part = to.params.slug;

      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/dashboard-of-all-projects',
    component: () => import('../Pages/Reports/NewDashboard.vue'),
    name: 'NewDashboard',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/student-attendance',
    component: () => import('../Pages/Attendance/StudentAttendanceList.vue'),
    name: 'StudentAttendance',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
        return;
      }
      const campusPerms = (
        store.state.auth.user.campusPermissions || []
      ).flatMap(c => c.permissions || []);
      if (
        campusPerms.includes('report.list') ||
        campusPerms.includes('report.show')
      ) {
        next();
      } else {
        next({ path: '/' });
      }
    }
  },
  {
    path: '/reports',
    component: () => import('../Pages/Reports/Layout.vue'),
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    children: [
      {
        path: '',
        component: () => import('../Pages/Reports/Reports.vue'),
        name: 'Reports',
        meta: {
          requiresAuth: true,
          part: 'students'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      },
      {
        path: 'template',
        component: () => import('../Pages/Reports/Template.vue'),
        name: 'ReportsTemplate',
        meta: {
          requiresAuth: true,
          part: 'students'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      },
      {
        path: 'dashboard',
        component: () => import('../Pages/Reports/Dashboard.vue'),
        name: 'ReportsDashboard',
        meta: {
          requiresAuth: true,
          part: 'students'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      }
    ]
  },
  {
    path: '/reports-year',
    component: () => import('../Pages/ReportYear.vue'),
    name: 'ReportYear',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
const blank_pdf_routes = [];
const study_center_new = [
  {
    path: '/study-center-new',
    component: () => import('../Pages/StudyCenterNew/StudyCenterNew.vue'),
    name: 'StudyCenterTemplate',
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
const study_center = [
  {
    path: '/lessons-all-students',
    component: () =>
      import('../Pages/StudyCenterNew/ReproachesAllStudents.vue'),
    name: 'ReproachesAllStudents',
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:slug/template',
    component: () => import('../Pages/StudyCenter/Template.vue'),
    name: 'StudyCenterTemplate',
    meta: {
      requiresAuth: true,
      part: 'center'
    },
    beforeEnter: (to, from, next) => {
      to.meta.part = to.params.slug;

      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:slug/reports',
    component: () => import('../Pages/StudyCenter/Report/Month.vue'),
    name: 'ReportMonth',
    meta: {
      requiresAuth: true,
      part: 'center'
    },
    beforeEnter: (to, from, next) => {
      to.meta.part = to.params.slug;
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:slug/reports-week',
    component: () => import('../Pages/StudyCenter/Report/Week.vue'),
    name: 'ReportWeek',
    meta: {
      requiresAuth: true,
      part: 'center'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:slug/dashboard',
    component: () => import('../Pages/StudyCenterV2/StudyDashboard.vue'),
    name: 'StudyDashboard',
    meta: {
      requiresAuth: true,
      part: 'study-center'
    },
    beforeEnter: (to, from, next) => {
      to.meta.part = to.params.slug;
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:slug/rule-report',
    component: () => import('../Pages/StudyCenter/Report/RuleReport.vue'),
    name: 'RuleReport',
    meta: {
      requiresAuth: true,
      part: 'study-center'
    },
    beforeEnter: (to, from, next) => {
      to.meta.part = to.params.slug;

      const slug = to.params.slug;
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:slug/month',
    component: () => import('../Pages/StudyCenter/Month.vue'),
    name: 'StudyCenterMonth',
    meta: {
      requiresAuth: true,
      part: 'center'
    },
    beforeEnter: (to, from, next) => {
      to.meta.part = to.params.slug;

      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  // {
  //   path: '/centers/:slug/week',
  //   component: () => import('../Pages/StudyCenter/Week.vue'),
  //   name: 'StudyCenterWeek',
  //   meta: {
  //     requiresAuth: true,
  //     part: 'study-center'
  //   }
  // },
  {
    path: '/study-center/student-week',
    component: () => import('../Pages/StudyCenter/StudentWeek.vue'),
    name: 'StudyCenterStudentWeek',
    meta: {
      requiresAuth: true,
      part: 'study-center'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:day/day',
    component: () => import('../Pages/StudyCenter/Day.vue'),
    name: 'StudyCenterDay',
    meta: {
      requiresAuth: true,
      part: 'center'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },

  {
    // Legacy static paths → default center.
    path: '/study-center-v2/day',
    redirect: '/study-center-v2/study-center/day'
  },
  {
    path: '/study-center-v2/week',
    redirect: '/study-center-v2/study-center/week'
  },
  {
    // Study Center v2 — rewrite of the ACTIVE StudyCenterNew day page
    // (/centers/:slug/day). Path deliberately OUTSIDE /centers/* so the
    // earlier '/centers/:slug/day' route can't swallow it as a slug.
    // :slug = study-center category url (same list as the legacy menu).
    path: '/study-center-v2/:slug/day',
    component: () => import('../Pages/StudyCenterV2/DayView.vue'),
    name: 'StudyCenterV2Day',
    meta: {
      requiresAuth: true,
      part: 'study-center'
    },
    beforeEnter: (to, from, next) => {
      to.meta.part = to.params.slug;
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/study-center-v2/:slug/week',
    component: () => import('../Pages/StudyCenterV2/WeekView.vue'),
    name: 'StudyCenterV2Week',
    meta: {
      requiresAuth: true,
      part: 'study-center'
    },
    beforeEnter: (to, from, next) => {
      to.meta.part = to.params.slug;
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:slug/pdf',
    component: () => import('../Pages/StudyCenterNew/Blocks/DayPdf.vue'),
    name: 'StudyCenterDayPDF',
    meta: {
      requiresAuth: true,
      part: 'center',
      layout: 'lessons-pdf'
    },
    beforeEnter: (to, from, next) => {
      to.meta.part = to.params.slug;
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/study-center/new-day',
    component: () => import('../Pages/StudyCenter/NewDay.vue'),
    name: 'StudyCenterNewDay',
    meta: {
      requiresAuth: true,
      part: 'center'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/centers/:slug/reports',
    component: () => import('../Pages/StudyCenter/Report/Layout.vue'),
    meta: {
      requiresAuth: true,
      part: 'center'
    },
    beforeEnter: (to, from, next) => {
      to.meta.part = to.params.slug;
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    children: [
      // {
      //   path: '',
      //   component: () => import('../Pages/StudyCenter/Report/Month.vue'),
      //   name: 'ReportMonth',
      //   meta: {
      //     requiresAuth: true,
      //     part: 'center'
      //   },
      //   beforeEnter: (to, from, next) => {
      //     to.meta.part = to.params.slug;
      //     if (store.state.auth.user.entity_id === 2) {
      //       next({ name: 'ReproachesSchedule' });
      //     } else {
      //       next();
      //     }
      //   }
      // }
      // {
      //   path: '',
      //   component: () => import('../Pages/StudyCenter/Report/RuleReport.vue'),
      //   name: 'RuleReport',
      //   meta: {
      //     requiresAuth: true,
      //     part: 'study-center'
      //   },
      //   beforeEnter: (to, from, next) => {
      //     to.meta.part = to.params.slug;
      //     const slug = to.params.slug;
      //     if (store.state.auth.user.entity_id === 2) {
      //       next({ name: 'ReproachesSchedule' });
      //     } else {
      //       next();
      //     }
      //   }
      // },
      // {
      //   path: '',
      //   component: () => import('../Pages/StudyCenter/Report/Week.vue'),
      //   name: 'ReportWeek',
      //   meta: {
      //     requiresAuth: true,
      //     part: 'study-center'
      //   },
      //   beforeEnter: (to, from, next) => {
      //     to.meta.part = to.params.slug;
      //     if (store.state.auth.user.entity_id === 2) {
      //       next({ name: 'ReproachesSchedule' });
      //     } else {
      //       next();
      //     }
      //   }
      // }
    ]
  },

  {
    path: '/centers/:slug/rule-report',
    component: () => import('../Pages/StudyCenter/Report/Layout.vue'),
    meta: {
      requiresAuth: true,
      part: 'center'
    },
    beforeEnter: (to, from, next) => {
      to.meta.part = to.params.slug;
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    children: [
      {
        path: '',
        component: () => import('../Pages/StudyCenter/Report/RuleReport.vue'),
        name: 'RuleReport',
        meta: {
          requiresAuth: true,
          part: 'center'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      }
    ]
  },

  {
    path: '/centers/:slug/reports-week',
    component: () => import('../Pages/StudyCenter/Report/Layout.vue'),
    meta: {
      requiresAuth: true,
      part: 'center'
    },
    beforeEnter: (to, from, next) => {
      to.meta.part = to.params.slug;
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    children: [
      {
        path: '',
        component: () => import('../Pages/StudyCenter/Report/Week.vue'),
        name: 'ReportWeek',
        meta: {
          requiresAuth: true,
          part: 'center'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      }
    ]
  }
];
const worker_routes = [
  {
    path: '/projects',
    component: () =>
      import('../Pages/AdministrationProjects/SchoolProjects.vue'),
    name: 'SchoolProjects',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/knowledge-center-categories',
    component: () => import('../Pages/KnowledCenter/Categories.vue'),
    name: 'KnowledCenterCategories',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/knowledge-center-category',
    component: () => import('../Pages/KnowledCenter/pages/Category.vue'),
    name: 'KnowledCenterCategory',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/projects-groups',
    component: () =>
      import('../Pages/AdministrationProjects/ProjectsTeamTable.vue'),
    name: 'ProjectsTeamTable',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/additional-groups',
    component: () =>
      import('../Pages/AdministrationProjects/GroupsAllTables.vue'),
    name: 'GroupsAllTables',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/additional-projects',
    component: () =>
      import('../Pages/AdministrationProjects/ProjectsAllTables.vue'),
    name: 'ProjectsAllTables',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/schedule-of-all-projects',
    component: () =>
      import('../Pages/AdministrationProjects/ScheduleOfAllProjects.vue'),
    name: 'ScheduleOfAllProjects',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/report-of-all-projects',
    component: () =>
      import('../Pages/AdministrationProjects/ReportOfAllProjects.vue'),
    name: 'ReportOfAllProjects',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/report-of-all-projects/travel-reports',
    component: () =>
      import('../Pages/AdministrationProjects/WorkersKmReports.vue'),
    name: 'WorkersKmReports',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/worker-hours-worked',
    component: () =>
      import('../Pages/AdministrationProjects/WorkerHoursWorked.vue'),
    name: 'WorkerHoursWorked',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/main-project-info',
    component: () =>
      import('../Pages/AdministrationProjects/MainProjectInfo.vue'),
    name: 'MainProject',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/group-info',
    component: () =>
      import('../Pages/AdministrationProjects/MainGroupInfo.vue'),
    name: 'MainGroupInfo',
    meta: {
      requiresAuth: true,
      part: 'projects'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },

  {
    path: '/administration-tables',
    component: () =>
      import('../Pages/AdministrationResours/AdministrationResours.vue'),
    name: 'AdministrationResours',
    meta: {
      requiresAuth: true,
      part: 'administrations'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/institutions-additional-tables',
    component: () =>
      import(
        '../Pages/AdministrationResours/SchoolMenagment/InstitutionsAllTables.vue'
      ),
    name: 'InstitutionsAllTables',
    meta: {
      requiresAuth: true,
      part: 'administrations'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  // {
  //   path: '/district-administration-management',
  //   component: () =>
  //     import(
  //       '../Pages/AdministrationResours/AdministrationMenagment/AdministrationMenagment.vue'
  //     ),
  //   name: 'AdministrationMenagment',
  //   meta: {
  //     requiresAuth: true,
  //     part: 'workers'
  //   },
  //   beforeEnter: (to, from, next) => {
  //     if (store.state.auth.user.entity_id === 2) {
  //       next({ name: 'ReproachesSchedule' });
  //     } else {
  //       next();
  //     }
  //   }
  // },
  {
    path: '/district-administration-contacts',
    component: () =>
      import(
        '../Pages/AdministrationResours/AdministrationMenagment/Tabs/DistrictAdministrationContacts.vue'
      ),
    name: 'DistrictAdministrationContacts',
    meta: {
      requiresAuth: true,
      part: 'workers'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },

  {
    path: '/institution-info',
    component: () =>
      import(
        '../Pages/AdministrationResours/SchoolMenagment/Tabs/SchoolInfo.vue'
      ),
    name: 'SchoolInfo',
    meta: {
      requiresAuth: true,
      part: 'workers'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },

  {
    path: '/workers-list',
    component: () => import('../Pages/Worker/WorkersList.vue'),
    name: 'WorkersList',
    meta: {
      requiresAuth: true,
      part: 'workers'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },

  {
    path: '/workers-delete-list',
    component: () => import('../Pages/Worker/WorkersDeleteList.vue'),
    name: 'WorkersDeleteList',
    meta: {
      requiresAuth: true,
      part: 'workers'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/worker-add',
    component: () => import('../Pages/Worker/WorkerAdd.vue'),
    name: 'WorkerAdd',
    meta: {
      requiresAuth: true,
      part: 'workers'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/worker/:id',
    component: () => import('../Pages/Worker/Worker.vue'),
    name: 'Worker',
    meta: {
      requiresAuth: true,
      part: 'workers'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
const setting_routes = [
  {
    path: '/settings',
    component: () => import('../Pages/Settings/Settings.vue'),
    name: 'Settings',
    meta: {
      requiresAuth: true,
      part: 'settings'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/settings-departments',
    component: () => import('../Pages/Settings/DepartmentList.vue'),
    name: 'DepartmentsList',
    meta: {
      requiresAuth: true,
      part: 'settings'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/settings/roles',
    component: () => import('../Pages/Settings/RoleList.vue'),
    name: 'RolesList',
    meta: {
      requiresAuth: true,
      part: 'settings'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/settings-management-list',
    component: () => import('../Pages/Settings/ManagementList.vue'),
    name: 'ManagementList',
    meta: {
      requiresAuth: true,
      part: 'settings'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
const auth_routes = [
  {
    path: '/passkey-settings',
    component: () => import('../Pages/PasskeySettings.vue'),
    name: 'PasskeySettings',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/sign-in',
    component: () => import('../Pages/SignIn.vue'),
    name: 'SignIn',
    meta: {
      layout: 'auth-layout'
    }
  },
  {
    path: '/gul/:slug',
    component: () => import('../Pages/StudyCenter/EditLessonPage.vue'),
    name: 'EditLessonPage',
    meta: {
      layout: 'guest-layout'
    }
  },
  {
    path: '/gum/:lesson/:group',
    component: () =>
      import(
        '../Pages/AdministrationProjects/Pages/OpenPageLessonGroupEdit.vue'
      ),
    name: 'OpenPageLessonGroupEdit',
    meta: {
      layout: 'guest-layout'
    }
  },
  {
    path: '/forgot-password',
    component: () => import('../Pages/ForgotPassword.vue'),
    name: 'ForgotPassword',
    meta: {
      layout: 'auth-layout'
    }
  },

  {
    path: '/first-change-password',
    component: () => import('../Pages/FirstChangePassword.vue'),
    name: 'FirstChangePassword',
    meta: {
      layout: 'auth-layout',
      requiresAuth: true
    }
  },
  {
    path: '/reset-password/:token',
    component: () => import('../Pages/ResetPassword.vue'),
    name: 'ResetPassword',
    meta: {
      layout: 'auth-layout'
    }
  },
  {
    path: '/login',
    component: () => import('../Pages/SignIn.vue'),
    name: 'SignIn',
    meta: {
      layout: 'auth-layout'
    }
  },
  {
    path: '/sign-in-confirm',
    component: () => import('../Pages/ConfirmAuth.vue'),
    name: 'Confirm',
    meta: {
      layout: 'auth-layout'
    }
  }
];
const maintenance_routes = [
  {
    path: '/service-orders',
    component: () => import('../Pages/Maintenance/ServiceOrderList.vue'),
    name: 'ServiceOrderList',
    meta: {
      requiresAuth: true,
      part: 'maintenance'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/service-order-old/:order',
    component: () => import('../Pages/Maintenance/ServiceOrder.vue'),
    name: 'ServiceOrderOld',
    meta: {
      requiresAuth: true,
      part: 'maintenance'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/service-order/:order',
    component: () => import('../Pages/Maintenance/ServiceOrderNew.vue'),
    name: 'ServiceOrder',
    meta: {
      requiresAuth: true,
      part: 'maintenance'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
const security_routes = [
  {
    path: '/proptech-serial-numbers',
    component: () =>
      import('../Pages/ProptechSerialNumbers/ProptechSerialNumbers.vue'),
    name: 'ProptechSerialNumbers',
    meta: {
      requiresAuth: true,
      part: 'security'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/security',
    component: () => import('../Pages/Security/Security.vue'),
    meta: {
      requiresAuth: true,
      part: 'security'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    children: [
      {
        path: 'entry',
        component: () => import('../Pages/Security/EntryPermit'),
        name: 'Security',
        meta: {
          requiresAuth: true,
          part: 'security'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      },
      {
        path: 'student',
        component: () => import('../Pages/Security/StudentPermit'),
        name: 'StudentPermit',
        meta: {
          requiresAuth: true,
          part: 'security'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      },
      {
        path: 'student-permission',
        component: () => import('../Pages/Security/StudentPermission'),
        name: 'StudentPermission',
        meta: {
          requiresAuth: true,
          part: 'security'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      },
      {
        path: 'worker-guest-permission',
        component: () => import('../Pages/Security/WorkerGuestPermission'),
        name: 'WorkerGuestPermission',
        meta: {
          requiresAuth: true,
          part: 'security'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      },

      {
        path: 'dashboard',
        component: () => import('../Pages/Security/Dashboard'),
        name: 'PermitDashboard',
        meta: {
          requiresAuth: true,
          part: 'security'
        },
        beforeEnter: (to, from, next) => {
          if (store.state.auth.user.entity_id === 2) {
            next({ name: 'ReproachesSchedule' });
          } else {
            next();
          }
        }
      }
    ]
  },
  {
    path: '/own-permission',
    component: () => import('../Pages/Security/OwnPermits'),
    name: 'OwnPermits',
    meta: {
      requiresAuth: true,
      part: 'own_permits'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
const blanks_routes = [
  {
    path: '/commission-blanks',
    component: () => import('../Pages/BehaviorBlank/CommissionBlanks.vue'),
    name: 'CommissionBlanks',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/incident-blanks',
    component: () => import('../Pages/BehaviorBlank/IncidentBlanks.vue'),
    name: 'IncidentBlanks',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/personal-conversation-blanks',
    component: () =>
      import('../Pages/BehaviorBlank/PersonalConversationBlanks.vue'),
    name: 'PersonalConversationBlanks',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/coordinators-blanks',
    component: () => import('../Pages/BehaviorBlank/CoordinatorBlanks.vue'),
    name: 'CoordinatorBlanks',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/coordinator-blanks-print',
    component: () => import('../Pages/Prints/CoordinatorBlanksPrint'),
    name: 'CoordinatorBlanksPrint',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    // props: route => ({
    //   id: route.params.id,
    //   user: route.params.user
    // }),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/coordinators-print',
    component: () => import('../Pages/Prints/CoordinatorsPrint'),
    name: 'CoordinatorsPrint',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    // props: route => ({
    //   id: route.params.id,
    //   user: route.params.user
    // }),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },

  {
    path: '/coordinators-print-desctop',
    component: () => import('../Pages/Prints/CoordinatorsPrintDesctop'),
    name: 'CoordinatorsPrintDesctop',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    // props: route => ({
    //   id: route.params.id,
    //   user: route.params.user
    // }),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/coordinators-print-modal',
    component: () => import('../Pages/Prints/CoordinatorsModalPrint'),
    name: 'CoordinatorsModalPrint',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    // props: route => ({
    //   id: route.params.id,
    //   user: route.params.user
    // }),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/assessment-blanks',
    component: () => import('../Pages/BehaviorBlank/AssessmentBlanks.vue'),
    name: 'AssessmentBlanks',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/feedback-blanks',
    component: () => import('../Pages/BehaviorBlank/FeedbackBlanks.vue'),
    name: 'FeedbackBlanks',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/parent-blanks',
    component: () => import('../Pages/BehaviorBlank/ParentBlanks.vue'),
    name: 'ParentBlanks',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  }
];
let routes = [
  // ==== PORTED FROM PROD: blanks / dashboards / AI pages ====
  {
    path: '/student-blanks',
    component: () => import('../Pages/StudentPages/MyBlanks.vue'),
    name: 'StudentMyBlanks',
    meta: {
      requiresAuth: true,
      part: 'students'
    }
  },
  {
    path: '/my-worker-blanks',
    component: () => import('../Pages/WorkerPages/MyBlanks.vue'),
    name: 'WorkerMyBlanks',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/my-dashboard',
    component: () => import('../Pages/StudentDashboard.vue'),
    name: 'StudentDashboardHome',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mobile-menu',
    component: () => import('../Pages/MobileMenu.vue'),
    name: 'MobileMenu',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/custom-blank-templates',
    component: () => import('../Pages/BehaviorBlank/CustomBlankTemplates.vue'),
    name: 'CustomBlankTemplates',
    props: {
      initialViewMode: 'list'
    },
    meta: {
      requiresAuth: true,
      part: 'blank_dashboards'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/custom-blank-templates/dashboard',
    component: () =>
      import('../Pages/BehaviorBlank/CustomBlankTemplatesDashboard.vue'),
    name: 'CustomBlankTemplatesDashboard',
    meta: {
      requiresAuth: true,
      part: 'blank_dashboards'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/custom-blank-templates/students',
    component: () =>
      import('../Pages/BehaviorBlank/CustomBlankTemplatesStudents.vue'),
    name: 'CustomBlankTemplatesStudents',
    meta: {
      requiresAuth: true,
      part: 'students'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/custom-blank-templates/workers',
    component: () =>
      import('../Pages/BehaviorBlank/CustomBlankTemplatesWorkers.vue'),
    name: 'CustomBlankTemplatesWorkers',
    meta: {
      requiresAuth: true,
      part: 'workers'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/ai-usage',
    component: () => import('../Pages/AiUsage/AiUsage.vue'),
    name: 'AiUsage',
    meta: {
      requiresAuth: true,
      part: 'ai_usage'
    },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    }
  },
  {
    path: '/',
    component: () => import('../Pages/HomePage.vue'),
    name: 'HomePage',
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      next({ name: 'MobileDashbord' });
    }
  }
];
const relative_routes = [
  {
    path: '/relatives-list',
    component: () => import('../Pages/Relative/RelativeList.vue'),
    name: 'RelativeList',
    beforeEnter: (to, from, next) => {
      // Students never see the relatives directory, mirrors student-list gate.
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    meta: {
      requiresAuth: true,
      part: 'relatives'
    }
  },
  {
    path: '/relative/:id',
    component: () => import('../Pages/Relative/RelativeEdit.vue'),
    name: 'RelativeEdit',
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    meta: {
      requiresAuth: true,
      part: 'relatives'
    }
  },
  // Parent-facing pages: only relatives (entity_id===4) see them.
  // The parent area is now a single page — the exit-requests table with the
  // create drawer on top (the old /parent/dashboard was removed).
  {
    path: '/parent/exit-requests',
    component: () => import('../Pages/Parent/ParentExitRequests.vue'),
    name: 'ParentExitRequests',
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id !== 4) {
        next({ name: 'StudentList' });
      } else {
        next();
      }
    },
    meta: { requiresAuth: true, part: 'parent' }
  },
  // Admin settings — relative access role templates.
  {
    path: '/settings/relative-access-roles',
    component: () => import('../Pages/Settings/RelativeAccessRoles.vue'),
    name: 'RelativeAccessRoles',
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 4) {
        next({ name: 'ParentExitRequests' });
      } else if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    meta: { requiresAuth: true, part: 'settings' }
  },
  // Staff side — review parent exit requests (approve/reject + convert
  // into exit permits). Gated by entity_id !== 4 (staff/admin only).
  {
    path: '/staff/parent-exit-requests',
    component: () =>
      import('../Pages/StaffExitRequests/StaffParentRequests.vue'),
    name: 'StaffParentRequests',
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user.entity_id === 4) {
        next({ name: 'ParentExitRequests' });
      } else if (store.state.auth.user.entity_id === 2) {
        next({ name: 'ReproachesSchedule' });
      } else {
        next();
      }
    },
    meta: { requiresAuth: true, part: 'security' }
  }
];

routes = routes.concat(relative_routes);
routes = routes.concat(auth_routes);
routes = routes.concat(student_routes);
routes = routes.concat(study_center);
routes = routes.concat(worker_routes);
routes = routes.concat(maintenance_routes);
routes = routes.concat(setting_routes);
routes = routes.concat(blank_pdf_routes);
routes = routes.concat(blanks_routes);
routes = routes.concat(security_routes);
const all_routes = routes;
// meta:
// requiresAuth: -  only for auth users
// part: -  for header menu
// item: -  for sidebar menu
export default all_routes;
